import { useAuth0 } from '@auth0/auth0-react';

export const useCreateServiceListing = () => {
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    const createService = async (formData) => {
        const token = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_API_AUDIENCE,
            },
        });
        const response = await fetch(`${apiUrl}/api/services`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        if (!response.ok) {
            throw new Error('Failed to create service');
        }
        return await response.json();
    };

    return { createService };
};

export default useCreateServiceListing;
